import React, { useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material'; 
import { selectKajeRegister } from '../Selectors/StitchSelector/StitchingSelectors';
import { fetchKajeRegister } from '../../Store/PHPSlice/Kaje/KajeApi';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

const KajeInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        ordType:'',
        kjMemo: '',
        sreMemo: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        kId: '',
    firmId: '',
    empId: '',
    itemId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totQty: '',
        instruction: ''
    });
    const [returnMemoNo, setReturnMemoNo] = useState('');
    
const [qtyData, setQtyData] = useState({
    returnQty: [],
    damageQty: [],
    extraQty: [],
    balQty: []
});
const [returnCount, setReturnCount] = useState(1);
const [saving, setSaving] = useState(false);
    const { Id } = useParams();
    const dispatch = useDispatch();
    const kajelist = useSelector(selectKajeRegister);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchKajeRegister(Id))
    }, [Id, dispatch]);
    useEffect(() => {
        if (kajelist.data && kajelist.data.length > 0) {
            const item = kajelist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: item.dt,
                ordType:item.ordType,
                kjMemo: item.kjMemo,
                sreMemo: item.sreMemo,
                totQty: item.totQty,
                instruction: item.instruction,
                empNm: item.empNm,
                itemNm: item.itemNm,
                soId: item.soId,
                sono: item.sono,
                kId: item.ID || item.kId,
            firmId: item.firmId,
            empId: item.empId,
            itemId: item.itemId,
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
            }));
        }
    }, [kajelist]);

useEffect(() => {
    if (kajelist?.Info?.length > 0) {

        const totalRows = kajelist.Info.length;

        setQtyData({
            returnQty: new Array(totalRows).fill('0'),
            damageQty: new Array(totalRows).fill('0'),
            extraQty: new Array(totalRows).fill('0'),
            balQty: kajelist.Info.map(val =>
                parseFloat(val.issqty || 0)
            )
        });
    }
}, [kajelist]);
useEffect(() => {
    if (formData.kjMemo) {

        const generatedMemo =
            `R-${formData.kjMemo}-${returnCount}`;

        setReturnMemoNo(generatedMemo);
    }
}, [formData.kjMemo, returnCount]);


useEffect(() => {

    const getReturnCount = async () => {

        if (!formData.kjMemo) return;

        try {

            const response = await axios.post(
                `${baseUrl}?apicall=getKajeReturnCount`,
                {
                    kjMemo: formData.kjMemo
                }
            );

            const count =
                response.data?.count || 0;
                console.log("res=>",response.data);
            setReturnMemoNo(
                `R-${formData.kjMemo}-${Number(count) + 1}`
            );

        } catch (error) {
            console.log(error);
        }
    };

    getReturnCount();

}, [formData.kjMemo]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // var itemData = kajelist.Info.length > 0 ? {
    //     size: kajelist.Info.map(val => val.size),
    //     sreqty: kajelist.Info.map(val => parseFloat(val.sreqty)),
    //     issqty: kajelist.Info.map(val => parseFloat(val.issqty)),
    //     balqty: kajelist.Info.map(val => parseFloat(val.balqty)),
    // } : [];
    const itemData = kajelist?.Info?.length > 0
    ? {
        size: kajelist.Info.map(val => val.size),
        sreqty: kajelist.Info.map(val => parseFloat(val.sreqty)),
        issqty: kajelist.Info.map(val => parseFloat(val.issqty)),
        balqty: kajelist.Info.map(val => parseFloat(val.balqty)),
    }
    : {
        size: [],
        sreqty: [],
        issqty: [],
        balqty: [],
    };

const handleQtyChange = (index, field, value) => {

    const updated = { ...qtyData };

    updated[field][index] = value;

    const issueQty =
        parseFloat(itemData.issqty[index]) || 0;

    const returnQty =
        parseFloat(updated.returnQty[index]) || 0;

    const damageQty =
        parseFloat(updated.damageQty[index]) || 0;

    const extraQty =
        parseFloat(updated.extraQty[index]) || 0;

    // BALANCE CALCULATION
    updated.balQty[index] =
        issueQty - returnQty - damageQty + extraQty;

    setQtyData(updated);
};
const handleSubmit = async () => {
    console.log("SUBMIT CALLED");

    if (saving) return;

    setSaving(true);

    try {
        const postData = {
            dt: formData.dt,
            kjMemo: formData.kjMemo,
            returnMemoNo: returnMemoNo,
            kId: formData.kId,
            firmId: formData.firmId,
            soId: formData.soId,
            empId: formData.empId,
            itemId: formData.itemId,
            totQty: formData.totQty,
            inwQty: formData.totQty,

            details: itemData.size.map((size, index) => ({
                size,
                qty: itemData.sreqty[index],
                issueQty: itemData.issqty[index],
                returnQty: qtyData.returnQty[index] || 0,
                damageQty: qtyData.damageQty[index] || 0,
                extraQty: qtyData.extraQty[index] || 0,
                balQty: qtyData.balQty[index] || 0
            }))
        };

        console.log("POST DATA =>", postData);

        const response = await axios.post(
            `${baseUrl}?apicall=insertKajeReturn`,
            postData
        );

        console.log(response.data);
        alert(response.data.msg);
        window.close();

    } catch (error) {
        console.log(error);
        alert('Something went wrong');
    } finally {
        setSaving(false);
    }
};
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '5% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Kaje Return Entry</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                  <td style={{ width: '200px' }}>Kaje Return Date</td>

<td
    style={{
        width: '30vw',
        padding: '0.2% 1.5%'
    }}
>
    <input
        type="date"
        value={formData.dt || ''}
        onChange={(e) =>
            setFormData(prev => ({
                ...prev,
                dt: e.target.value
            }))
        }
        style={{
            width: '150px',
            height: '28px',
            textAlign: 'center',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '2px 6px'
        }}
    />
</td>
                                    <td style={{ width: '200px' }}>Order Type</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.ordType}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Kaje Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.kjMemo}</td>

                                    <td style={{ width: '200px' }}>Stitching Return Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sreMemo}</td>

                                </tr>
                                <tr>
    <td style={{ width: '200px' }}>
        Kaje Return Memo No.
    </td>

    <td
        style={{
            width: '30vw',
            padding: '0.2% 1.5%'
        }}
    >
        <input
            type="text"
            value={returnMemoNo}
            onChange={(e) =>
                setReturnMemoNo(e.target.value)
            }
            readOnly
            style={{
            width: '150px',
            height: '28px',
            textAlign: 'center',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '2px 6px',
            color:'blue',
            fontWeight:'bold'
        }}
        />
    </td>
</tr>

                                {formData.soId !== '0' &&

                                    <tr>
                                        <td style={{ width: '200px' }}>Sale Order No.</td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>

                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>


                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>
                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }


                            </tbody>

                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>

                                    <td style={{ width: '200px' }}>Kaje Instructions</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                </tr>
                            </tbody>
                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                               <TableBody>

    {/* SIZE */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000', width: '150px' }}
            align='center'
            className='tbl-row'
        >
            Size
        </TableCell>

        {itemData.size.map((val, index) => (
            <TableCell
                key={index}
                sx={{ p: 1, border: '1px solid #000' }}
                align='center'
            >
                {val}
            </TableCell>
        ))}
    </TableRow>

    {/* QTY */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000' }}
            align='center'
            className='tbl-row'
        >
            Qty.
        </TableCell>

        {itemData.sreqty.map((val, index) => (
            <TableCell
                key={index}
                sx={{ p: 1, border: '1px solid #000' }}
                align='center'
            >
                {val}
            </TableCell>
        ))}
    </TableRow>

    {/* ISSUE QTY */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000' }}
            align='center'
            className='tbl-row'
        >
            Issue Qty.
        </TableCell>

        {itemData.issqty.map((val, index) => (
            <TableCell
                key={index}
                sx={{ p: 1, border: '1px solid #000' }}
                align='center'
            >
                {val}
            </TableCell>
        ))}
    </TableRow>

    {/* RETURN QTY */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000' }}
            align='center'
            className='tbl-row'
        >
            Return Qty.
        </TableCell>

       {qtyData.returnQty.map((val, index) => (
    <TableCell
        key={index}
        align="center"
        sx={{
            border: '1px solid #000',
            padding: '2px !important',
            height: '35px',
            verticalAlign: 'middle'
        }}
    >
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <input
                type="number"
                value={val}
                onChange={(e) =>
                    handleQtyChange(
                        index,
                        'returnQty',
                        e.target.value
                    )
                }
                style={{
                    width: '70px',
                    height: '22px',
                    textAlign: 'center',
                    fontSize: '12px',
                    border: '1px solid #999',
                    borderRadius: '3px',
                    padding: '0'
                }}
            />
        </div>
    </TableCell>
))}
    </TableRow>

    {/* DAMAGE QTY */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000' }}
            align='center'
            className='tbl-row'
        >
            Damage Qty.
        </TableCell>

        {qtyData.damageQty.map((val, index) => (
    <TableCell
        key={index}
        align="center"
        sx={{
            border: '1px solid #000',
            padding: '2px !important',
            height: '35px',
            verticalAlign: 'middle'
        }}
    >
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <input
                type="number"
                value={val}
                onChange={(e) =>
                    handleQtyChange(
                        index,
                        'damageQty',
                        e.target.value
                    )
                }
                style={{
                    width: '70px',
                    height: '22px',
                    textAlign: 'center',
                    fontSize: '12px',
                    border: '1px solid #999',
                    borderRadius: '3px',
                    padding: '0'
                }}
            />
        </div>
    </TableCell>
))}
    </TableRow>

    {/* EXTRA QTY */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000' }}
            align='center'
            className='tbl-row'
        >
            Extra Qty.
        </TableCell>

           {qtyData.extraQty.map((val, index) => (
    <TableCell
        key={index}
        align="center"
        sx={{
            border: '1px solid #000',
            padding: '2px !important',
            height: '35px',
            verticalAlign: 'middle'
        }}
    >
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <input
                type="number"
                value={val}
                onChange={(e) =>
                    handleQtyChange(
                        index,
                        'extraQty',
                        e.target.value
                    )
                }
                style={{
                    width: '70px',
                    height: '22px',
                    textAlign: 'center',
                    fontSize: '12px',
                    border: '1px solid #999',
                    borderRadius: '3px',
                    padding: '0'
                }}
            />
        </div>
    </TableCell>
))}
    </TableRow>

    {/* BALANCE QTY */}
    <TableRow>
        <TableCell
            sx={{ p: 1, border: '1px solid #000' }}
            align='center'
            className='tbl-row'
        >
            Bal Qty.
        </TableCell>

            {qtyData.balQty.map((val, index) => (
    <TableCell
        key={index}
        align="center"
        sx={{
            border: '1px solid #000',
            padding: '2px !important',
            height: '35px',
            verticalAlign: 'middle'
        }}
    >
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <input
                type="number"
                value={val}
                onChange={(e) =>
                    handleQtyChange(
                        index,
                        'balQty',
                        e.target.value
                    )
                }
                style={{
                    width: '70px',
                    height: '22px',
                    textAlign: 'center',
                    fontSize: '12px',
                    border: '1px solid #999',
                    color:'#f00',
                    fontWeight:'bold',
                    borderRadius: '3px',
                    padding: '0'
                }}
            />
        </div>
    </TableCell>
))}
    </TableRow>

</TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                 <div
    style={{
        margin: '2% 5%',
        paddingBottom: '2%',
        display: 'flex',
        gap: '10px'
    }}
>
   <Button
    type="button"
    variant="contained"
    color="primary"
    onClick={handleSubmit}
    disabled={saving}
>
    {saving ? 'Saving...' : 'Save'}
</Button>

  
</div>
                </Paper>
            </Grid>
        </>
    );
};

export default KajeInfo;
